/* eslint-disable no-unused-expressions, no-sequences */
import { isEmpty } from 'lodash'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  MereFormItem,
  MeresFieldsFormValues,
} from '@modals/RiskMapModal/Dangers/DangersFields/DangersFieldsBlock/DangersFieldsMeresModalButton/MeresFields'
import {
  ProtectionMeanItem,
  ProtectionMeansFieldsFormValues,
} from '@modals/RiskMapModal/Dangers/DangersFields/DangersFieldsBlock/DangersFieldsProtectionMeansModalButton/ProtectionMeansFields'
import { DangersApi } from '@services/dangers'
import { protectionMeansApi } from '@services/protectionMeans'
import { convertMeanToForm } from '@utils/riskMap'
import { PositionOption } from '@models/position'
import { log } from '@utils/console'

export type State = {
  selectedMeresForms: MeresFieldsFormValues[]
  selectedProtectionMeansForms: ProtectionMeansFieldsFormValues[]
  meresIsVisibleIndex: number | null
  protectionMeansIsVisibleIndex: number | null
  selectDangersModalIsVisible: boolean
  selectedMainPosition: PositionOption | null
}

export const initialState: State = {
  selectedMeresForms: [
    {
      prefilled: false,
      notAutoAddControlMeasures: false,
      meres: [{} as MereFormItem],
    },
  ],
  selectedProtectionMeansForms: [
    {
      prefilled: false,
      notAutoAddProtectionMeans: false,
      protectionMeans: [{} as ProtectionMeanItem],
    },
  ],
  meresIsVisibleIndex: null,
  protectionMeansIsVisibleIndex: null,
  selectDangersModalIsVisible: false,
  selectedMainPosition: null,
}

export const riskMapModalSlice = createSlice({
  name: 'riskMapModal',
  initialState,
  reducers: {
    setSelectDangersModalIsVisible: (
      state,
      { payload }: PayloadAction<boolean>
    ) => {
      log('setSelectDangersModalIsVisible payload', payload)
      state.selectDangersModalIsVisible = payload
    },
    setSelectedMeresForms: (
      state,
      { payload }: PayloadAction<MeresFieldsFormValues[]>
    ) => {
      log('setSelectedMeresForms payload', payload)
      state.selectedMeresForms = payload
    },
    updateSelectedMeresForms: (
      state,
      {
        payload,
      }: PayloadAction<{
        index: number
        value: MeresFieldsFormValues
      }>
    ) => {
      log('updateSelectedMeresForms payload', payload)
      state.selectedMeresForms[payload.index] = payload.value
    },
    setSelectedProtectionMeansForms: (
      state,
      { payload }: PayloadAction<ProtectionMeansFieldsFormValues[]>
    ) => {
      log('setSelectedProtectionMeansForms payload', payload)
      state.selectedProtectionMeansForms = payload
    },
    updateSelectedProtectionMeansForms: (
      state,
      {
        payload,
      }: PayloadAction<{
        index: number
        value: ProtectionMeansFieldsFormValues
      }>
    ) => {
      log('updateSelectedProtectionMeansForms payload', payload)
      state.selectedProtectionMeansForms[payload.index] = payload.value
    },
    setMeresIsVisibleIndex: (
      state,
      { payload }: PayloadAction<number | null>
    ) => {
      log('setMeresIsVisibleIndex payload', payload)
      state.meresIsVisibleIndex = payload
    },
    setProtectionMeansIsVisibleIndex: (
      state,
      { payload }: PayloadAction<number | null>
    ) => {
      log('setProtectionMeansIsVisibleIndex payload', payload)
      state.protectionMeansIsVisibleIndex = payload
    },
    cleanAllForms: () => {
      log('cleanAllForms')
      return initialState
    },
    deleteSelectedProtectionMeansForms: (
      state,
      { payload }: PayloadAction<number>
    ) => {
      log('deleteSelectedProtectionMeansForms payload', payload)
      state.selectedProtectionMeansForms =
        state.selectedProtectionMeansForms.filter(
          (_item, index) => payload !== index
        )
    },
    deleteSelectedMeresForms: (state, { payload }: PayloadAction<number>) => {
      log('deleteSelectedMeresForms payload', payload)
      state.selectedMeresForms = state.selectedMeresForms.filter(
        (_item, index) => payload !== index
      )
    },
    setSelectedMainPosition: (
      state,
      { payload }: PayloadAction<PositionOption | null>
    ) => {
      log('setSelectedMainPosition payload', payload)
      state.selectedMainPosition = payload
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      DangersApi.endpoints.getDangersSearchedMeres.matchFulfilled,
      (state, { payload: { items, modalIndex = 0 } }) => {
        if (isEmpty(items)) return

        if (!state.selectedMeresForms[modalIndex]) {
          state.selectedMeresForms[modalIndex] =
            initialState.selectedMeresForms[0]
        }

        state.selectedMeresForms[modalIndex].meres = items.map((mere) => ({
          mereKind: {
            ...mere.kind,
            label: mere.kind.value,
            value: mere.kind.value,
          },
          content: {
            ...mere.content,
            label: mere.content.value,
            value: mere.content.value,
          },
          source: undefined,
          completionStartDate: undefined,
          completionEndDate: undefined,
          eventRepetitionFrequency: undefined,
          responsible: undefined,
        }))
      }
    ),
      builder.addMatcher(
        protectionMeansApi.endpoints.getDangersSearchedProtectionMeans
          .matchFulfilled,
        (state, { payload: { items, modalIndex = 0 } }) => {
          if (isEmpty(items)) return

          if (!state.selectedProtectionMeansForms[modalIndex]) {
            state.selectedProtectionMeansForms[modalIndex] =
              initialState.selectedProtectionMeansForms[0]
          }

          state.selectedProtectionMeansForms[modalIndex].protectionMeans =
            items.map((mean) => convertMeanToForm(mean))
        }
      )
  },
})

export const {
  setSelectedMeresForms,
  updateSelectedMeresForms,
  setSelectedProtectionMeansForms,
  updateSelectedProtectionMeansForms,
  cleanAllForms,
  setMeresIsVisibleIndex,
  setProtectionMeansIsVisibleIndex,
  setSelectDangersModalIsVisible,
  deleteSelectedProtectionMeansForms,
  deleteSelectedMeresForms,
  setSelectedMainPosition,
} = riskMapModalSlice.actions

export default riskMapModalSlice.reducer
